String.prototype.hashCode = function() {
  var hash = 0, i, chr;
  if (this.length === 0) return hash;
  for (i = 0; i < this.length; i++) {
    chr   = this.charCodeAt(i);
    hash  = ((hash << 5) - hash) + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
};

window.findProductByVariantId = function(products, variantId) {
	for (var i = 0; i < products.length; i++) {
		if(products[i].variantId == variantId) {
			return products[i];
		}
	}
	return false;
}

window.dlCheckoutPush = function(dlProducts, step) {
	// var previousCheckoutToken = dlGetCookie('dl_checkout_token'); // this disappears after set, which is really weird...so basically it's useless. Anyway, for now, the if(step) would exclude the Thank You page reload situation. So, let's mind it one day if Shopify change that.
	// var currentCheckoutToken = Shopify.Checkout && Shopify.Checkout.token ? Shopify.Checkout.token.hashCode() : false;
	// console.log(previousCheckoutToken);
	// console.log(currentCheckoutToken);
	if(step && step != 'processing') {
		// Thank You (checkout complete) page seems to removed the 'step' variable inside Shopify.Checkout if refreshing the Thank You page.
		
		// if(step != 'thank_you' || !previousCheckoutToken || previousCheckoutToken != currentCheckoutToken) {
			// var postcode = dlGetCookie('shopify_checkout_postcode') ? dlGetCookie('shopify_checkout_postcode') : dlShopify.customerPostcode;
			// if(!postcode || postcode == '') {
			// 	postcode = 'n/a';
			// }
			var postcode = dlShopify.customerPostcode;
			if(!postcode || postcode == '') {
				postcode = 'n/a';
			}

		    var ecKey = 'checkout';
			if(step == 'thank_you') {
		    	ecKey = 'purchase';
		    }
			var dataToPush = {
		      'event': 'custom.ecom.' + ecKey,
		      'checkoutStepName': step,
		      'postcode': postcode,
		    };
		    
		    dataToPush.ecommerce = {};
		    dataToPush.ecommerce[ecKey] = {};

		    if(step == 'thank_you') {
	    		dataToPush.ecommerce[ecKey].actionField = {
					'id': Shopify.checkout && Shopify.checkout.order_id ? Shopify.checkout.order_id : 'n/a',
					'affiliation': 'Thankyou', // Thankyou
					'revenue': Shopify.checkout && Shopify.checkout.total_price ? Shopify.checkout.total_price : 'n/a',
					'tax': Shopify.checkout && Shopify.checkout.total_tax ? Shopify.checkout.total_tax : 'n/a',
					'shipping': Shopify.checkout && Shopify.checkout.shipping_rate ? Shopify.checkout.shipping_rate.price : 'n/a',
					'coupon': Shopify.checkout && Shopify.checkout.discount && Shopify.checkout.discount.code ? Shopify.checkout.discount.code : 'n/a'
				};

		    	// document.cookie = "dl_checkout_token=" + currentCheckoutToken;
		    }
		    dataToPush.ecommerce[ecKey].products = dlProducts;
			dataLayer.push(dataToPush);

			// // delete the postcode cookie after Checkout completed
			// // this doesn't seem to work
			// if(step == 'thank_you') {
			// 	document.cookie = "shopify_checkout_postcode=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
			// }
		// }
	}
}

// not in use
window.dlSetCookie = function(cname, cvalue, exdays) {
	if(!exdays) {
		expires = false;
	} else {
		var d = new Date();
	    d.setTime(d.getTime() + (exdays*24*60*60*1000));
	    var expires = "expires="+ d.toUTCString();
	}
    
    var cookie = cname + "=" + cvalue;
    if(expires) {
		cookie += ";" + expires + ";path=/";
    }
    document.cookie = cookie;
}

function dlGetCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return false;
}